import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    refreshStatesUrl: String,
    refreshCitiesUrl: String,
    statesFrame: String,
    citiesFrame: String
  }

  async refreshStates(event) {
    const countryId = event?.target?.value?.toString() || ""
    const { statesUrl, statesFrame, citiesUrl, citiesFrame } = this.resolveConfig(event?.target)

    if (statesUrl && statesFrame) {
      await this.visitFrame(`${statesUrl}${encodeURIComponent(countryId)}`, statesFrame)
    }

    if (citiesUrl && citiesFrame) {
      // Limpa cidades ao trocar país.
      await this.visitFrame(`${citiesUrl}`, citiesFrame)
    }
  }

  async refreshCities(event) {
    const stateId = event?.target?.value?.toString() || ""
    const { citiesUrl, citiesFrame } = this.resolveConfig(event?.target)
    if (!citiesUrl || !citiesFrame) return

    await this.visitFrame(`${citiesUrl}${encodeURIComponent(stateId)}`, citiesFrame)
  }

  resolveConfig(target) {
    const identifier = this.identifier
    const configHost = target?.closest("[data-zip-lookup-refresh-states-url-value], [data-zip-lookup-refresh-cities-url-value]") || this.element

    const statesUrl = this.readConfigValue(configHost, [
      `${identifier}RefreshStatesUrlValue`,
      "zipLookupRefreshStatesUrlValue"
    ])
    const citiesUrl = this.readConfigValue(configHost, [
      `${identifier}RefreshCitiesUrlValue`,
      "zipLookupRefreshCitiesUrlValue"
    ])
    const statesFrame = this.readConfigValue(configHost, [
      `${identifier}StatesFrameValue`,
      "zipLookupStatesFrameValue"
    ])
    const citiesFrame = this.readConfigValue(configHost, [
      `${identifier}CitiesFrameValue`,
      "zipLookupCitiesFrameValue"
    ])

    return { statesUrl, citiesUrl, statesFrame, citiesFrame }
  }

  readConfigValue(host, keys) {
    return keys.map((key) => host?.dataset?.[key]).find((value) => value && String(value).trim().length > 0) || ""
  }

  visitFrame(url, frameId) {
    if (!url || !frameId) return Promise.resolve()

    const frame = document.getElementById(frameId)
    if (!frame) {
      Turbo.visit(url, { frame: frameId })
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      const onLoad = () => resolve()
      frame.addEventListener("turbo:frame-load", onLoad, { once: true })
      Turbo.visit(url, { frame: frameId })
    })
  }
}
